export interface CreateApiUserRequest {
  organizationId: string; // GUID
  displayName: string;
}

export interface UpdateApiUserRequest {
  organizationId: string; // GUID
  apiUserId: string; // GUID
  displayName: string;
}

export enum ApiUserSecretStatus {
  NotSet = "NotSet",
  Current = "Current",
  Expired = "Expired"
}

export interface AzureApplicationUserModel {
  id: string; // GUID
  name: string; // Example: "ApiUser.72c045bf-****-4cc2-****-1dd1702e586e.TestUserDev"
  createdOn: Date | string; // Example: "2026-05-26T11:42:35+00:00"
  secretStatus: ApiUserSecretStatus;
}

export type AzureApplicationUserModelKeys = keyof AzureApplicationUserModel;

// export interface ApiUsersResponse {
//   readonly users: AzureApplicationUserModel[];
// }
